import React, { useState, useEffect, useContext } from "react";
import "../../Sass/Components/_UniversitySettings.scss";
import InputField from "./InputField";
import InputDropdown from "./InputDropdown";
import DragAndDropUpload from "./DragAndDropUpload";
import ToggleButton from "./ToggleButton";
import Checkbox from "./Checkbox";
import Tooltip from "./Tooltip";
import Button from "../Button";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import { getDataFromStorage } from "../../util";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
import SideNav from "../Student/Profile/SideNav";
import ProfileUpload from "../Student/Profile/ProfileUpload.js";
import Loading from "../Notification-Loading/Loading/Loading";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
import constants from "../../constants";
import AlertContext from "../../context/AlertContext";
import PhoneInput from "react-phone-input-2";
import Toast from "./Toast.js";
import UserValidationHook from "../../Hooks/UserValidationHook.js";
let base64Regex =
  /^data:image\/(png|jpeg|jpg|gif|webp);base64,[A-Za-z0-9+/=]+$/;

const UniversitySettings = () => {
   const {
      validateFirstName,
      validateLastName,
      validateEmail,
      validateMobile,
    } = UserValidationHook();
  const Alert = useContext(AlertContext);
  const companyId = getDataFromStorage("companyId");
  const { getPreSignedUrl, onUploadS3Object } = useS3FileManagement();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [premiumOptions, setPremiumOptions] = useState([]);
  const [expandedFeatures, setExpandedFeatures] = useState({});
  const [activeTab, setActiveTab] = useState("universityInfo");
  const [errors, setErrors] = useState({});
  const [details, setDetails] = useState({
    universityName: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile : "",
    learningPathSharing: 0,
    topicSharing: 0,
    premiumFeatures: [],
    maxLearners: "",
    videoAttemptLimit: "",
    logo: null,
    favicon: null,
    type: "",
    contact_info: "",
    address : "",
  });

  const [tempDetails, setTempDetails] = useState(details);
  const [logoUrl, setLogoUrl] = useState(null);
  const [faviconUrl, setFaviconUrl] = useState(null);
  const [toast, setToast] = useState({ open: false, type: "success", message: "" });
  const showToast = (type, message) => setToast({ open: true, type, message });
  const closeToast = () => setToast((prev) => ({ ...prev, open: false }));

  useEffect(() => {
    fetchUniversitySettings();
    fetchPremiumFeatures();
    fetchPremiumFeatures();
  }, []);

  useEffect(() => {
    if (premiumOptions.length && tempDetails.premiumFeatures.length) {
      setTempDetails((prev) => ({
        ...prev,
        premiumFeatures: [...prev.premiumFeatures],
      }));
    }
  }, [premiumOptions]);

  const axios = useAxiosPrivate();
  const commonHooks = useCommonFunctionHooks();

  const fetchPremiumFeatures = async () => {
    try {
      setLoading(true);
      const response = await axios.get("node/admin/premium-features");
      console.log("Premium Features API Response:", response.data);

      if (response.data?.data) {
        const formatted = response.data.data.map((item) => ({
          label: item.label,
          value: item.id,
          subFeatures:
            typeof item.sub_features === "string"
              ? JSON.parse(item.sub_features)
              : item.sub_features || [],
        }));

        setPremiumOptions(formatted);
        const initialExpanded = {};
        formatted.forEach((feature) => {
          initialExpanded[feature.value] = true;
        });
        setExpandedFeatures(initialExpanded);
      }
    } catch (error) {
      console.error("Error fetching premium features:", error);
      commonHooks.getCatchBlockDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUniversitySettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`node/admin/company/${companyId}`);
      const apiData = response.data.data;
      console.log("University Settings API Response:", apiData);
      console.log(
        "\n\n\n\nallow feature\n\n\n",
        Number(apiData.allow_lp_sharing),
      );
      let premiumFeatures = [];

      if (apiData.premium_data) {
        const parsedPremiumData = JSON.parse(apiData.premium_data);

        if (Array.isArray(parsedPremiumData)) {
          if (parsedPremiumData.length > 0) {
            if (typeof parsedPremiumData[0] === "object") {
              premiumFeatures = parsedPremiumData.map((p) => p.id || p.name);
            } else if (typeof parsedPremiumData[0] === "string") {
              premiumFeatures = parsedPremiumData
                .map((name) => {
                  const match = premiumOptions.find(
                    (opt) => opt.label.toLowerCase() === name.toLowerCase(),
                  );
                  return match?.value;
                })
                .filter(Boolean);
            } else {
              premiumFeatures = parsedPremiumData;
            }
          }
        }
      }

      const formattedData = {
        universityName: apiData.name || "",
        admins: apiData.adminDetails
          ? JSON.parse(apiData.adminDetails).map((admin) => ({
              firstName: admin.firstname,
              lastName: admin.lastname,
              email: admin.email,
              mobile:admin.mobile,
            }))
          : [],
        learningPathSharing: Number(apiData.allow_lp_sharing) || 0,
        topicSharing: Number(apiData.allow_topic_sharing) || 0,
        maxLearners: apiData.max_learners || "",
        videoAttemptLimit: apiData.video_interview_attempt_limit || "",
        premiumFeatures: premiumFeatures,
        logo: apiData.logo || null,
        favicon: apiData.favicon || null,
        type: Number(apiData.type) === 1 ? "University" : "corporate",
        address:apiData.address,
        contact_info: apiData.contact_info
          ? JSON.parse(apiData.contact_info)?.email || ""
          : "",
      };
      console.log("apiData for this :", apiData);
      const keys = [apiData.logo, apiData.favicon].filter(Boolean);

      if (keys.length > 0) {
        const res = await getPreSignedUrl(keys, undefined, "", "GET");
        const urls = res?.url || [];
        let index = 0;

        if (apiData.logo) {
          formattedData.logoSignedUrl = urls[index] || null;
          index++;
        }
        if (apiData.favicon) {
          formattedData.faviconSignedUrl = urls[index] || null;
        }
      }
      setDetails(formattedData);
      setTempDetails({ ...formattedData });
    } catch (error) {
      console.error("Error fetching university settings:", error);
      commonHooks.getCatchBlockDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setTempDetails({ ...details });
    setIsEditing(true);
  };

  const handleCancel = () => {
    setTempDetails({ ...details });
    setIsEditing(false);
    setErrors("");
  };

  const handleSave = async () => {

    try {
      setLoading(true);
      if (!validateAll()) {
        showToast("error", "Please fill in all required fields correctly.");
        return;
      }
      let logoKey = tempDetails.logo;
      let faviconKey = tempDetails.favicon;
      const regex =
        /^data:image\/(png|jpeg|jpg|gif|webp);base64,[A-Za-z0-9+/=]+$/;
      if (regex.test(tempDetails.logo) || regex.test(tempDetails.favicon)) {
        const timestamp = Date.now();
        const files = [tempDetails.logo, tempDetails.favicon];
        const fileTypes = files.map((file) =>
          regex.test(file)
            ? file.match(/^data:(image\/(\w+));base64,(.+)$/)[2]
            : null,
        );

        const keys = [
          fileTypes[0]
            ? `university/${tempDetails.universityName}_${timestamp}.${fileTypes[0]}`
            : tempDetails.logo,
          fileTypes[1]
            ? `university/${tempDetails.universityName}_${timestamp}.${fileTypes[1]}`
            : tempDetails.favicon,
        ];

        function base64ToFile(dataUrl, fileName = "file") {
          const [meta, base64] = dataUrl.split(",");
          const mime = meta.match(/:(.*?);/)[1];

          const binary = atob(base64);
          const bytes = new Uint8Array(binary.length);

          for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
          }

          return new File([bytes], fileName, { type: mime });
        }

        for (let i = 0; i < files.length; i++) {
          if (regex.test(files[i])) {
            const fileObject = base64ToFile(
              files[i],
              `${tempDetails.universityName}_${timestamp}.${fileTypes[i]}`,
            );
            if (fileObject instanceof File) {
              await onUploadS3Object(
                keys[i],
                fileObject,
                fileTypes[i],
                undefined,
                "PUT",
              );
            }
          }
        }

        logoKey = keys[0];
        faviconKey = keys[1];
      }

      console.log("logoKey", logoKey, "faviconKey", faviconKey);

      const formData = new FormData();
      formData.append("name", tempDetails.universityName);
      const adminDetails = (details.admins || []).map((admin) => ({
        firstname: admin.firstName || "",
        lastname: admin.lastName || "",
        email: admin.email || "",
        mobile:admin.mobile || "",
      }));
      formData.append("adminDetails", JSON.stringify(adminDetails));
      formData.append("contact_info", JSON.stringify({ email: tempDetails.contact_info }));
      formData.append("allow_lp_sharing", tempDetails.learningPathSharing);
      formData.append("allow_topic_sharing", tempDetails.topicSharing);
      formData.append("max_learners", tempDetails.maxLearners);
      formData.append(
        "video_interview_attempt_limit",
        tempDetails.videoAttemptLimit,
      );
      formData.append("logo", logoKey);
      formData.append("favicon", faviconKey);
      formData.append(
        "premium_features",
        JSON.stringify(tempDetails.premiumFeatures),
      );
      formData.append("type", tempDetails.type === "University" ? 1 : 2);
      formData.append("address",tempDetails.address);
      console.log("FormData : ", formData);
      const response = await axios.put(
        `node/admin/company/${companyId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Save Response:", response.data);
      await fetchUniversitySettings();
      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        Alert.setShowNotify({
          show: true,
          title: "Success",
          msg: response.data.msg || "University created successfully",
        });
      }
      else {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: response.data.error.msg || "Failed to update university settings",
        });
      }
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating settings:", error);
      commonHooks.getCatchBlockDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const validateField = (key, value) => {
    const trimmed = (value || "").toString().trim();
    let errorMsg = "";

    if (key === "universityName") {
      if (!trimmed) errorMsg = "University name is required";
      else if (trimmed.length > 50) errorMsg = "Must be 50 characters or less";
    } else if (key === "contact_info") {
      if (!trimmed) errorMsg = "Email is required";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) errorMsg = "Enter a valid email";
    } else if (key === "maxLearners") {
      if (!value || +value <= 0) errorMsg = "Enter valid learner count";
    } else if (key === "videoAttemptLimit") {
      if (!value || +value <= 0) errorMsg = "Enter valid attempt limit";
    }else if (key === "address") {
      if (!trimmed) errorMsg = "Location is required";
      else if (trimmed.length > 50) errorMsg = "Must be 50 characters or less";
    }else if (key === "accountType") {
      if (!trimmed) errorMsg = "Account type is required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
  };

  const validateAll = () => {
    const e = {};
    if(tempDetails.universityName?.trim().length>50)  e.universityName = "University Name must be less than 50 Characters";
      if(tempDetails.address?.trim().length>50)  e.address = "Location must be less than 50 Characters";
    // if(!tempDetails.accountType) e.accountType = "Account type is required";
    if(!tempDetails.address?.trim()) e.address = "Location is required";
    if (!tempDetails.universityName?.trim()) e.universityName = "University name is required";
    // if (!tempDetails.logo) e.logo = "Logo is required";
    // if (!tempDetails.favicon) e.favicon = "Favicon is required";
    const emailErr = validateEmail(tempDetails.contact_info);
    if (emailErr) e.contact_info = emailErr;

    // tempDetails.admins.forEach((admin, i) => {
    //   const fnErr = validateFirstName(admin.firstName);
    //   const lnErr = validateLastName(admin.lastName);
    //   const emErr = validateEmail(admin.email);
    //   const mobErr = validateMobile(admin.contactnumber);

    //   if (fnErr) e[`firstName_${i}`] = fnErr;
    //   if (lnErr) e[`lastName_${i}`] = lnErr;
    //   if (emErr) e[`email_${i}`] = emErr;
    //   if (mobErr) e[`contactnumber_${i}`] = mobErr;
    // });
    // const emailCounts = tempDetails.admins.reduce((acc, admin) => {
    //   const email = admin.email?.trim().toLowerCase();
    //   if (email) acc[email] = (acc[email] || 0) + 1;
    //   return acc;
    // }, {});

    // tempDetails.admins.forEach((admin, i) => {
    //   const email = admin.email?.trim().toLowerCase();
    //   if (email && emailCounts[email] > 1 && !e[`email_${i}`]) {
    //     e[`email_${i}`] = "Email must be unique among admins";
    //   }
    // });
    // const contactCounts = tempDetails.admins.reduce((acc, admin) => {
    // const contact = admin.contactnumber?.trim();
    //   if (contact) acc[contact] = (acc[contact] || 0) + 1;
    //   return acc;
    // }, {});

    // tempDetails.admins.forEach((admin, i) => {
    //   const contact = admin.contactnumber?.trim();
    //   if (
    //     contact &&
    //     contactCounts[contact] > 1 &&
    //     !e[`contactnumber_${i}`]
    //   ) {
    //     e[`contactnumber_${i}`] =
    //       "Contact number must be unique among admins";
    //   }
    // });
    // if (!tempDetails.maxLearners || +tempDetails.maxLearners <= 0) {
    //   e.maxLearners = "Enter valid learner count";
    // }

    // if (!tempDetails.videoAttemptLimit || +tempDetails.videoAttemptLimit <= 0) {
    //   e.videoAttemptLimit = "Enter valid attempt limit";
    // }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (name, value) => {
    setTempDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateField(name,value);
  };

  const handleParentChange = (option) => {
    if (!isEditing) return;

    const existing = tempDetails.premiumFeatures || [];

    if (!option.subFeatures || option.subFeatures.length === 0) {
      let updated;
      if (existing.includes(option.value)) {
        updated = existing.filter((id) => id !== option.value);
      } else {
        updated = [...existing, option.value];
      }
      handleChange("premiumFeatures", updated);
      return;
    }

    const subIds = option.subFeatures.map((sub) => sub.id);
    const allSelected = subIds.every((id) => existing.includes(id));

    let updated;
    if (allSelected) {
      updated = existing.filter((id) => !subIds.includes(id));
    } else {
      updated = [...new Set([...existing, ...subIds])];
    }
    handleChange("premiumFeatures", updated);
  };

  const handleSubFeatureChange = (subId) => {
    if (!isEditing) return;

    const existing = tempDetails.premiumFeatures || [];
    let updated;

    if (existing.includes(subId)) {
      updated = existing.filter((id) => id !== subId);
    } else {
      updated = [...existing, subId];
    }
    handleChange("premiumFeatures", updated);
  };

  const toggleFeature = (featureId) => {
    setExpandedFeatures((prev) => ({
      ...prev,
      [featureId]: !prev[featureId],
    }));
  };

  const isFeatureChecked = (option) => {
    const selected = tempDetails.premiumFeatures || [];
    if (!option.subFeatures?.length) {
      return selected.includes(option.value);
    }
    return option.subFeatures.some((sub) => selected.includes(sub.id));
  };

  const isSubFeatureChecked = (subId) => {
    const selectedFeatures = tempDetails.premiumFeatures || [];
    return selectedFeatures.includes(subId);
  };

  // Menu items for the side navigation
  const menuListItems = [
    {
      id: 1,
      path: "universityInfo",
      text: "University Info",
      active: activeTab === "universityInfo",
      icon: <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
        <rect x="1" y="1" width="18" height="16" rx="3" stroke={activeTab === "universityInfo" ? "white" : "#F55533"} stroke-width="2">
        </rect>
        <path d="M1 6h18" stroke={activeTab === "universityInfo" ? "white" : "#F55533"} stroke-width="2">
        </path>
      </svg>
      ,
    },
    {
      id: 2,
      path: "features",
      text: "Features",
      active: activeTab === "features",
      icon: <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 15C13.4167 15 13.7708 14.8542 14.0625 14.5625C14.3542 14.2708 14.5 13.9167 14.5 13.5C14.5 13.0833 14.3542 12.7292 14.0625 12.4375C13.7708 12.1458 13.4167 12 13 12C12.5833 12 12.2292 12.1458 11.9375 12.4375C11.6458 12.7292 11.5 13.0833 11.5 13.5C11.5 13.9167 11.6458 14.2708 11.9375 14.5625C12.2292 14.8542 12.5833 15 13 15ZM13 18C13.5167 18 13.9917 17.8792 14.425 17.6375C14.8583 17.3958 15.2083 17.075 15.475 16.675C15.1083 16.4583 14.7167 16.2917 14.3 16.175C13.8833 16.0583 13.45 16 13 16C12.55 16 12.1167 16.0583 11.7 16.175C11.2833 16.2917 10.8917 16.4583 10.525 16.675C10.7917 17.075 11.1417 17.3958 11.575 17.6375C12.0083 17.8792 12.4833 18 13 18ZM8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V8.675C15.6833 8.54167 15.3583 8.42083 15.025 8.3125C14.6917 8.20417 14.35 8.125 14 8.075V4.4L8 2.15L2 4.4V9.1C2 9.88333 2.10417 10.6667 2.3125 11.45C2.52083 12.2333 2.8125 12.9792 3.1875 13.6875C3.5625 14.3958 4.01667 15.05 4.55 15.65C5.08333 16.25 5.675 16.75 6.325 17.15C6.50833 17.6833 6.75 18.1917 7.05 18.675C7.35 19.1583 7.69167 19.5917 8.075 19.975C8.05833 19.975 8.04583 19.9792 8.0375 19.9875C8.02917 19.9958 8.01667 20 8 20ZM13 20C11.6167 20 10.4375 19.5125 9.4625 18.5375C8.4875 17.5625 8 16.3833 8 15C8 13.6167 8.4875 12.4375 9.4625 11.4625C10.4375 10.4875 11.6167 10 13 10C14.3833 10 15.5625 10.4875 16.5375 11.4625C17.5125 12.4375 18 13.6167 18 15C18 16.3833 17.5125 17.5625 16.5375 18.5375C15.5625 19.5125 14.3833 20 13 20Z" fill={activeTab === "features" ? "white" : "#F55533"}/>
      </svg>
      ,
    },
    {
      id: 3,
      path: "userManagement",
      text: "User Management",
      active: activeTab === "userManagement",
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 14.5V11.4944C17 11.3149 17 11.2252 16.9727 11.146C16.9485 11.0759 16.9091 11.0121 16.8572 10.9592C16.7986 10.8993 16.7183 10.8592 16.5578 10.7789L12 8.5M4 9.5V16.3066C4 16.6785 4 16.8645 4.05802 17.0273C4.10931 17.1712 4.1929 17.3015 4.30238 17.4081C4.42622 17.5287 4.59527 17.6062 4.93335 17.7611L11.3334 20.6945C11.5786 20.8069 11.7012 20.8631 11.8289 20.8852C11.9421 20.9049 12.0579 20.9049 12.1711 20.8852C12.2988 20.8631 12.4214 20.8069 12.6666 20.6945L19.0666 17.7611C19.4047 17.6062 19.5738 17.5287 19.6976 17.4081C19.8071 17.3015 19.8907 17.1712 19.942 17.0273C20 16.8645 20 16.6785 20 16.3066V9.5M2 8.5L11.6422 3.67889C11.7734 3.61329 11.839 3.5805 11.9078 3.56759C11.9687 3.55616 12.0313 3.55616 12.0922 3.56759C12.161 3.5805 12.2266 3.61329 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z" stroke={activeTab === "userManagement" ? "white" : "#F55533"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      ,
    },
  ];

  // Render University Info Tab Content
  const renderUniversityInfo = () => (
    <>
      {loading && <Loading />}
      <div className="formField">
        <div className="formFieldWrapper">
          {/* <label>University Name</label> */}
          <div className="actionButtons">
            <InputField
              label="University Name"
              value={tempDetails?.universityName || ""}
              onChange={(e) => handleChange("universityName", e.target.value)}
              hintText={errors.universityName}
              destructive={!!errors.universityName}
              disabled={!isEditing || loading}
              placeholder="Enter university name"
            />
            <InputDropdown
              label="Account Type"
              value={tempDetails?.type || ""}
              onChange={(value) => handleChange("type", value)}
              options={[
                { label: "University", value: "University" },
                { label: "Corporate", value: "corporate" },
              ]}
              disabled={!isEditing || loading}
              placeholder="Select Account Type"
            />
          </div>
          <div className="actionButtons">
            <InputField
              label="Email"
              type="email"
              value={tempDetails?.contact_info || ""}
              // leadingIcon={<EmailIcon />}
              onChange={(e) => handleChange("contact_info", e.target.value)}
              placeholder="Enter the Email"
              // hintText={errors.email}
              // destructive={!!errors.email}
              hintText={errors.contact_info}
              destructive={!!errors.contact_info}
              disabled={!isEditing || loading}
              className="oa-label"
            />
            <InputField
              label="Location"
              value={tempDetails?.address || ""}
              // leadingIcon={<EmailIcon />}
              onChange={(e) => handleChange("address", e.target.value)}
              placeholder="Enter Location"
              hintText={errors.address}
              destructive={!!errors.address}
              disabled={!isEditing || loading}
              className="oa-label"
            />
          </div>
        </div>
      </div>

      <div className="sectionTitle">College admin details:</div>

      {(tempDetails.admins && tempDetails.admins.length > 0
        ? tempDetails.admins
        : [
          {
            firstName: tempDetails.firstName,
            lastName: tempDetails.lastName,
            email: tempDetails.email,
          },
        ]
      ).map((admin, index, arr) => (
        <div key={index}>
          <div className="formRow">
            <div className="formField">
              <label>First Name</label>
              <InputField
                value={admin.firstName}
                disabled={true}
                placeholder="Enter first name"
              />
            </div>

            <div className="formField">
              <label>Last Name</label>
              <InputField
                value={admin.lastName}
                disabled={true}
                placeholder="Enter last name"
              />
            </div>
          </div>
          <div className="formRow">
            <div className="formField">
              <label>Email-ID</label>
              <InputField
                value={admin.email}
                disabled={true}
                placeholder="Enter email address"
              />
            </div>

            <div className="formField-phone">
              <PhoneInput
                placeholder="Enter Number"
                onlyCountries={["us", "in"]}
                country="in"
                value={admin.mobile || ""}
                // onChange={(value) => setAdminField(index, "contactnumber", value)}
                // containerClass={errors[`contactnumber_${index}`] ? "has-error" : ""}
                countryCodeEditable={false}
                disabled={true}
                containerStyle={{ width: "100%" }}
                inputStyle={{
                  width: "100%",
                  height: "48px",
                  fontSize: "16px",
                  paddingLeft: "48px",
                }}
                buttonStyle={{
                  height: "48px",
                }}
              />
            </div>
          </div>

          {index !== arr.length - 1 && (
            <div
              style={{
                borderBottom: "1px solid #d0d5dd",
                margin: "20px 0",
              }}
            />
          )}
        </div>
      ))}
    </>
  );

  // Render Features Tab Content
  const renderFeatures = () => (
    <>
      {loading && <Loading />}
      <div className="featureSection">
        <div className="toggleRow">
          <label>Learning Path Sharing:</label>
          <ToggleButton
            pressed={tempDetails.learningPathSharing === 1}
            onChange={(checked) => {
              if (!isEditing || loading) return;
              handleChange("learningPathSharing", checked ? 1 : 0);
            }}
          />
          <span className="toggleStatus">
            {tempDetails.learningPathSharing === 1 ? "Enabled" : "Disabled"}
          </span>
        </div>

        <div className="toggleRow">
          <label>Topic Sharing:</label>
          <ToggleButton
            pressed={tempDetails.topicSharing === 1}
            onChange={(checked) => {
              if (!isEditing || loading) return;
              handleChange("topicSharing", checked ? 1 : 0);
            }}
          />
          <span className="toggleStatus">
            {tempDetails.topicSharing === 1 ? "Enabled" : "Disabled"}
          </span>
        </div>
      </div>

      <div className="featureSection">
        <div className="premiumBox">
          <div className="premiumHeader">Premium Features:</div>

          {premiumOptions.map((option) => {
            const isChecked = isFeatureChecked(option);

            return (
              <div key={option.value} className="premiumFeatureItem">
                <div className="featureItemHeader">
                  {option.subFeatures?.length > 0 && (
                    <span
                      className="expandIcon"
                      onClick={() =>
                        isEditing && !loading && toggleFeature(option.value)
                      }
                      style={{
                        cursor: isEditing && !loading ? "pointer" : "default",
                      }}
                    >
                      {expandedFeatures[option.value] ? "−" : "+"}
                    </span>
                  )}
                  <Checkbox
                    text={option.label}
                    checked={isChecked}
                    onChange={() => handleParentChange(option)}
                    disabled={!isEditing || loading}
                  />
                </div>

                {expandedFeatures[option.value] &&
                  option.subFeatures?.length > 0 && (
                    <div className="subFeaturesList">
                      {option.subFeatures.map((sub) => (
                        <div key={sub.id} className="subFeatureItem">
                          <Checkbox
                            text={sub.label}
                            checked={isSubFeatureChecked(sub.id)}
                            onChange={() => handleSubFeatureChange(sub.id)}
                            disabled={!isEditing || loading}
                          />
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            );
          })}

          {premiumOptions.length === 0 && (
            <div className="loadingMessage">Loading premium features...</div>
          )}
        </div>
      </div>

      <div className="featureSection">
        <div className="formField">
          <label>Maximum no. of learners:</label>
          <InputField
            type="number"
            value={tempDetails.maxLearners}
            onChange={(e) => handleChange("maxLearners", e.target.value)}
            disabled={!isEditing || loading}
            placeholder="Enter maximum learners"
          />
        </div>

        <div className="formField">
          <label>Video Interview attempt limit:</label>
          <InputField
            type="number"
            value={tempDetails.videoAttemptLimit}
            onChange={(e) => handleChange("videoAttemptLimit", e.target.value)}
            disabled={!isEditing || loading}
            placeholder="Enter attempt limit"
          />
        </div>
      </div>

      <div className="featureSection">
        <div className="uploadSection">
          {/* LOGO */}
          <div className="uploadItem">
            <label>College Logo</label>

            {!isEditing ? (
              // 👁 VIEW MODE (only show image)
              <div className="uploadPreview">
                {tempDetails.logo || tempDetails.logoSignedUrl ? (
                  <img
                    src={
                      base64Regex.test(tempDetails.logo)
                        ? tempDetails.logo
                        : tempDetails.logoSignedUrl
                    }
                    alt="Logo"
                  />
                ) : (
                  <span>No logo uploaded</span>
                )}
              </div>
            ) : (
              // ✏️ EDIT MODE (allow upload)
              <ProfileUpload
                from="settings"
                profilePic={
                  base64Regex.test(tempDetails.logo)
                    ? tempDetails.logo
                    : tempDetails.logoSignedUrl
                }
                setProfilePic={(file) => handleChange("logo", file)}
                handleResponse={() => { }}
                buttonText="Upload Logo"
                imageFit="fill"
                imageHeight={800}
                imageWidth={800}
                size="800 * 800"
              />
            )}
          </div>

          {/* FAVICON */}
          <div className="uploadItem">
            <label>Favicon</label>

            {!isEditing ? (
              <div className="uploadPreview">
                {tempDetails.favicon || tempDetails.faviconSignedUrl ? (
                  <img
                    src={
                      base64Regex.test(tempDetails.favicon)
                        ? tempDetails.favicon
                        : tempDetails.faviconSignedUrl
                    }
                    alt="Favicon"
                  />
                ) : (
                  <span>No favicon uploaded</span>
                )}
              </div>
            ) : (
              <ProfileUpload
                from="settings"
                profilePic={
                  base64Regex.test(tempDetails.favicon)
                    ? tempDetails.favicon
                    : tempDetails.faviconSignedUrl
                }
                setProfilePic={(file) => handleChange("favicon", file)}
                handleResponse={() => { }}
                buttonText="Upload Favicon"
                imageFit="fill"
                imageHeight={256}
                imageWidth={256}
                size="256 * 256"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );

  // Render User Management Tab Content
  const renderUserManagement = () => (
    <div className="emptyState">
      {loading && <Loading />}
      <div className="emptyStateContent">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
            stroke="#667085"
            strokeWidth="1.5"
          />
          <path
            d="M5 20V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V20"
            stroke="#667085"
            strokeWidth="1.5"
          />
          <circle cx="12" cy="12" r="11" stroke="#667085" strokeWidth="1.5" />
        </svg>
        <h3>User Management</h3>
        <p>This feature is coming soon. Stay tuned for updates!</p>
      </div>
    </div>
  );

  return (
    <div className="universitySettingsContainer">
      {loading && <Loading overlay/>}
      <div className="settingsHeader">
        <div className="headerLeft">
          <span className="companyIcon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                stroke="#344054"
                strokeWidth="2"
              />
            </svg>
          </span>
          <h2>University Details</h2>
        </div>

        {!isEditing ? (
          <Tooltip title="Edit Details" isIcon={true}>
            <span className="editBtn" onClick={handleEdit}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58578C2.21071 4.96086 2 5.46956 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10217 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z"
                  stroke="#667085"
                  strokeWidth="2"
                />
              </svg>
            </span>
          </Tooltip>
        ) : (
          <div className="editActions">
            <Button
              size="sm"
              onClick={handleCancel}
              hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
              disabled={loading}
            />
            <Button
              size="sm"
              onClick={handleSave}
              hierarchy={{ type: "primary", buttonText: "Save" }}
              disabled={loading}
            />
          </div>
        )}
      </div>

      <div className="mainContent">
        <div className="stickySideNav">
          <SideNav
            title="Settings"
            menuListItems={menuListItems}
            from="forpopup"
            onMenuClick={(item) => setActiveTab(item.path)}
            className="navbarwidth"
          />
        </div>

        <div className="contentArea">
          <div className="settingsFormContent">
            {activeTab === "universityInfo" && renderUniversityInfo()}
            {activeTab === "features" && renderFeatures()}
            {activeTab === "userManagement" && renderUserManagement()}
          </div>
        </div>
      </div>
      <Toast
        open={toast.open}
        type={toast.type}
        message={toast.message}
        onClose={closeToast}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </div>
  );
};

export default UniversitySettings;
